import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from "./NewPatternConsequence.module.css"
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";
import SubmitButtonWarning from "../../UI/SubmitButtonWarning/SubmitButtonWarning";

class NewPatternConsequence extends Component  {
    state = {
        pattern_consequences: [],
        pattern_consequence: {
            consequence_id: null,
            consequence_title: '',
            consequence_description: ''
        },
        showFailMessage: false,
        failMessage: ''
    };

    componentDidMount() {
        if (this.props.pattern_consequences !== []) {
            this.setState({pattern_consequences: this.props.pattern_consequences});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
    };

    postDataHandler = () => {
        const post = {
            consequence_id: this.state.pattern_consequence.consequence_id,
            consequence_title: this.state.pattern_consequence.consequence_title,
            consequence_description: this.state.pattern_consequence.consequence_description,
        };
        axios.post(apiUrl +'PatternConsequences/setPatternConsequence?token=' + this.props.token, post)
            .then(response => {
                if (!response.data.message) {
                    this.props.onNewPatternConsequence(response.data);
                    this.setState({
                        pattern_consequence: {
                            consequence_id: null,
                            consequence_title: '',
                            consequence_description: ''
                        }
                    });
                    this.props.newPatternConsequenceToggle();
                } else {
                    console.log(response.data.message)
                    this.setState({
                        showFailMessage: true,
                        failMessage: response.data.message
                    });
                }
            });


    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewPatternConsequencesBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                style={{marginBottom: 5}}
                                placeholder="Enter the name of the consequence you want to create."
                                value={this.state.pattern_consequence.consequence_title}
                                onChange={(event) => this.setState({pattern_consequence: {...this.state.pattern_consequence, consequence_title: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the consequence."
                                value={this.state.pattern_consequence.consequence_description}
                                onChange={(event) => this.setState({pattern_consequence: {...this.state.pattern_consequence, consequence_description: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newPatternConsequenceToggle}>Cancel</Button>
                        <SubmitButtonWarning
                            token={this.props.token} userId={this.props.userId}
                            handleSubmit={this.addHandler}
                            failMessage={this.state.failMessage}
                            setShowFailMessage={(show) => this.setState({showFailMessage: show})}
                            showFailMessage={this.state.showFailMessage}
                            postType={{
                                lowercase: "pattern consequence",
                                capital: "Pattern Consequence",
                                capitalLowercase: "Pattern consequence",
                            }}
                            submitButton={
                                <Button className="col-sm-3" variant="outline-primary" onClick={
                                    this.addHandler
                                }>Submit</Button>
                            }
                        />
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewPatternConsequence;